import { styled } from '@clickcease/cc-client-components-lib'

export const StyledLink = styled('a', {
  all: 'unset',
  fontWeight: '$sl',
  fontSize: '$md',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: '$primaryColor',
  userSelect: 'none',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
})
